import { defineMiddleware } from '../middleware'
import { useActiveChannelStore } from '@/entities/channel'

defineMiddleware('channel', (to) => {
  const channelId = to.params.channelId as string | undefined
  if (!channelId) return true

  const store = useActiveChannelStore()
  if (store.activeChannelId === channelId) return true

  store.setChannelId(channelId)
  return true
})
